"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function SurgicalCategoryBanner() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="140614" id="precision-peptide-synthesis" className="relative w-full bg-background overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-muted/30 to-background opacity-80 pointer-events-none" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-center gap-12 text-left transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex-1">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium text-foreground mb-4 md:mb-6 tracking-tight leading-tight">Advanced Research-Grade Peptides. Molecularly Verified. Precise.</h1>
          <p className="text-base sm:text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">Manufactured for laboratory use. Each batch tested for purity, stability, and molecular integrity.</p>
          <div className="mt-8 flex flex-wrap gap-3 md:gap-4">
            <Button asChild className="bg-foreground text-background hover:bg-foreground/90 rounded-sm px-6 py-3 md:px-10 md:py-4 h-auto text-base md:text-lg font-medium transition-colors">
              <Link to="#">Browse Products</Link>
            </Button>
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-sm px-6 py-3 md:px-10 md:py-4 h-auto text-base md:text-lg font-medium transition-colors">
              <Link to="#">View COA Library</Link>
            </Button>
          </div>
        </div>

        <div className="flex-1 w-full flex justify-center md:justify-end">
          <img src="https://supreme-hookworm.10web.cloud/wp-content/uploads/2026/04/image_xhazqln0.jpg" fetchPriority="high" alt="High-precision laboratory research environment" className="w-full max-w-lg lg:max-w-xl aspect-square object-cover rounded-sm shadow-sm border border-border/50" />
        </div>
      </div>
    </section>;
}